export default "__VITE_ASSET__BTPPOek$__"